import { useEffect } from 'react';

export const REVIEW_DIGEST_LOCAL_STORAGE_KEY = 'nushop-review-digest';
export const REVIEW_DIGEST_TOKEN_QUERY_KEY = 'reviewDigest';
export const REVIEW_DIGEST_VALID_TO_QUERY_KEY = 'validTo';

type ReviewDigest = { token: string; validTo: string };

export const useHandleReviewDigest = () => {
  useEffect(() => {
    deleteInvalidDigestsFromLS();
    const params = new URLSearchParams(window.location.search);

    if (params.has(REVIEW_DIGEST_TOKEN_QUERY_KEY)) {
      addNewDigestToLS(
        params.get(REVIEW_DIGEST_TOKEN_QUERY_KEY),
        params.get(REVIEW_DIGEST_VALID_TO_QUERY_KEY)
      );
    }
  }, []);
};

export const getReviewDigestsFromBrowser = () =>
  getValidDigestsOnly().map((x) => x.token);

const getDigestsFromLS = (): ReviewDigest[] => {
  const data = localStorage.getItem(REVIEW_DIGEST_LOCAL_STORAGE_KEY);
  if (!data) {
    return [];
  }
  try {
    const parsed = JSON.parse(data);
    if (!Array.isArray(parsed)) {
      return [];
    }
    return parsed;
  } catch (err) {
    return [];
  }
};

const getValidDigestsOnly = () =>
  getDigestsFromLS().filter(
    (digest) => digest.token && isDigestValid(digest.validTo)
  );

const saveToLS = (digests: ReviewDigest[]) => {
  localStorage.setItem(
    REVIEW_DIGEST_LOCAL_STORAGE_KEY,
    JSON.stringify(digests)
  );
};

const deleteInvalidDigestsFromLS = () => saveToLS(getValidDigestsOnly());

const isDigestValid = (validTo: string) => new Date(validTo) > new Date();

const addNewDigestToLS = (token: string, validTo: string) => {
  const existing = getValidDigestsOnly();
  if (existing.some((x) => x.token === token) || !isDigestValid(validTo)) {
    return;
  }
  const digest: ReviewDigest = { token, validTo };
  saveToLS([...existing, digest]);
};
